const isValidEmail = (value?: string): boolean | undefined => {
	if (!value) {
		return undefined;
	}
	const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
	return emailRegex.test(value.toString());
};

export default isValidEmail;
